import { SvgIcon, Typography } from "@mui/material";
import PlusIcon from "@static/icons/Plus.svg";
import { useStyle } from "./style";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IParams {
    title: string;
    subtitle?: string;
    onClick(): void;
    id?: string;
    isLoading?: boolean;
}

export const AddNewEquipment = (props: IParams) => {
    const { title, subtitle, onClick, id, isLoading = false } = props;
    const { classes } = useStyle();

    return (
        <LabeledButton
            className={`${classes.root}${isLoading ? ` ${classes.rootDisabled}` : ""}`}
            disableFullWidth
            disabled={isLoading}
            id={id}
            labelText={title}
            onClick={onClick}
        >
            <div className={classes.iconWrapper}>
                <SvgIcon className={classes.plusIcon} color="secondary" component={PlusIcon} inheritViewBox />
            </div>
            <div className={classes.textBlock}>
                <Typography className={classes.title} variant="normal">
                    {title}
                </Typography>
                {subtitle && <Typography variant="small">{subtitle}</Typography>}
            </div>
        </LabeledButton>
    );
};
